import React from 'react'
import DynamicMap from './DynamicMap'
import StaticMap from './StaticMap'
import AskForUpdate from '../genericComponents/AskForUpdate'
import './StaticMap.less'

const Map = (props) => (
  <>
    <StaticMap>{props.staticMap}</StaticMap>
    <DynamicMap {...props} />
    <AskForUpdate />
  </>
)

export default Map
